module.exports = __webpack_public_path__ + "static/media/waterpark6.23011c3e.jpg";